import { SquareFormAPI } from './SquareFormAPI';

export const square = {
  api: new SquareFormAPI(),
};
